<template>
  <div>
    <list-vue
      v-bind:busqueda="busqueda"
      v-bind:busquedaTraduccion="busquedaTraduccion"
      v-bind:busquedaMedidas="busquedaMedidas"
      v-bind:opciones="opciones"
      v-bind:moduloTitulo="moduloTitulo"
      v-bind:pantallaTitulo="pantallaTitulo"
      v-bind:rutaConsulta="rutaConsulta"
      v-bind:buttonsPage="buttonsPage"
      v-bind:busquedaCampos="busquedaCampos"
    ></list-vue>
  </div>
</template>
  <script type="text/javascript">
import { mapState } from "vuex";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      //Definimos los nombres generales
      moduloTitulo: this.$root.trans("Tabla de Clasificaciones de Registro"),
      reporte: false,
      pantallaTitulo: this.$root.trans("Resultado"),
      rutaConsulta: this.$route.fullPath,
      buttonsPage: [
        {
          type: "button",
          class: "btn btn-xs btn-info pull-right",
          route: "AuthorsCreate",
          text: '<i class="fa fa-plus">',
          external: "../../../../../editaclasificacion.php?filtroTipoNC=RE",
        },
      ],
      //Definimos los campos de busqueda, sus nombres e incluso tamaño
      busqueda: {
        codigo: "",
        descripcion: "",
        tipo_nc_codi: "",
        estado: "",
      },
      busquedaTraduccion: {
        codigo: this.$root.trans("Codigo"),
        descripcion: this.$root.trans("Descripción"),
        tipo_nc_codi: this.$root.trans("Tipo"),
        estado: this.$root.trans("Estado"),
      },
      busquedaCampos: {
        estado: {
          type: "select",
          options: [
            { label: "Activo", code: "A" },
            { label: "Desactivado", code: "B" },
          ],
        },
        tipo_nc_codi: {
          type: "select",
          options: [],
        },
      },
      busquedaMedidas: {
        codigo: "90px",
        descripcion: "30%",
        tipo_nc_codi: "30%",
        estado: "160px",
      },
      //definimos las opciones con enlace simple para ello usamos el nombre de la ruta y en caso de eliminar usamos la ruta
      opciones: [
        // {
        //   class: "btn btn-sm btn-warning",
        //   icon: "fas fa-edit",
        //   routerName: "TiposRegistroEdit",
        //   param: "codigo",
        //   eliminar: false,
        //   nombre: "Editar",
        // },
        // {
        //     class:'btn btn-sm btn-danger',
        //     icon:'fa fa-trash-alt',
        //     routerName:'/backend/authors/delete/',
        //     param:'id',
        //     eliminar:true,
        //     nombre:'Eliminar'
        // }
      ],
    };
  },
  computed: {
    ...mapState(["request"]),
  },
  methods: {
    ...mapMutations({ requestSet: "request" }),
  },
  mounted() {
    this.requestSet(this.$route.query);
  },
  created() {
    this.requestSet(this.$route.query);

    const data = {
      selects: {
        // User: {},
        TipoNC: { categoria_nc: "RE", estado: "all" },
      },
    };
    this.$root
      .Consulta(
        this.$root.UrlBase("selects/init"),
        data,
        "post",
        false,
        false,
        false,
        "",
        false
      )
      .then((response) => {
        this.busquedaCampos.tipo_nc_codi.options = response.TipoNC;
      });
  },
};
</script>
